var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgQuestionMark = function SvgQuestionMark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#question-mark_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M21.75 12a9.75 9.75 0 1 0-19.5 0 9.75 9.75 0 0 0 19.5 0M0 12a12 12 0 1 1 24 0 12 12 0 0 1-24 0m12-3.75c-.83 0-1.5.67-1.5 1.5 0 .623-.502 1.125-1.125 1.125A1.12 1.12 0 0 1 8.25 9.75 3.75 3.75 0 0 1 12 6a3.75 3.75 0 0 1 3.75 3.75c0 2.213-1.687 3.15-2.625 3.492v.178c0 .624-.502 1.125-1.125 1.125a1.12 1.12 0 0 1-1.125-1.125v-.38c0-.96.694-1.65 1.41-1.884.3-.098.62-.258.854-.483.202-.196.361-.468.361-.918 0-.83-.67-1.5-1.5-1.5zm-1.5 9a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "question-mark_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgQuestionMark;